<template>
  <div>
    <AbBucketIndex />
  </div>
</template>

<script setup>
import AbBucketIndex from './AbBuketIndex.vue';
</script>
